import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31bf1e14"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "row full-width justify-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createBlock(_component_q_item, {
    class: _normalizeClass([_ctx.InfoBoxPattern.get(_ctx.pattern).class, "info-box rounded-borders"])
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_q_spinner, {
              color: "primary",
              size: "3em"
            })
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_q_item_section, {
              side: "",
              top: _ctx.message !== null && _ctx.message !== undefined,
              center: !_ctx.message
            }, {
              default: _withCtx(() => [
                (!_ctx.hideIcon)
                  ? (_openBlock(), _createBlock(_component_q_icon, _mergeProps({
                      key: 0,
                      name: _ctx.InfoBoxPattern.get(_ctx.pattern).icon
                    }, _ctx.ICON_PROPS.BTN_LG, { class: "q-mr-xs" }), null, 16, ["name"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["top", "center"]),
            _createVNode(_component_q_item_section, {
              top: _ctx.message !== null && _ctx.message !== undefined,
              center: !_ctx.message
            }, {
              default: _withCtx(() => [
                (_ctx.title)
                  ? (_openBlock(), _createBlock(_component_q_item_label, _mergeProps({
                      key: 0,
                      class: "text-style"
                    }, _ctx.TEXT_CONTENT_BODY), {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
                        (_ctx.titleKey)
                          ? (_openBlock(), _createBlock(_component_i18n_t, {
                              key: 0,
                              keypath: "INFOBOX.TITLE_KEY",
                              tag: "strong"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.titleKey), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 16))
                  : _createCommentVNode("", true),
                (_ctx.message || _ctx.messageSlot)
                  ? (_openBlock(), _createBlock(_component_q_item_label, _normalizeProps(_mergeProps({ key: 1 }, _ctx.TEXT_SMALL_BODY)), {
                      default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "message", {}, () => [
                          _createTextVNode(_toDisplayString(_ctx.message), 1)
                        ], true)
                      ]),
                      _: 3
                    }, 16))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "more-info", {}, undefined, true)
              ]),
              _: 3
            }, 8, ["top", "center"]),
            (_ctx.action)
              ? (_openBlock(), _createBlock(_component_q_item_section, {
                  key: 0,
                  side: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_btn, _mergeProps(_ctx.BTN_SECONDARY_MD, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('action'))),
                      label: _ctx.action
                    }), null, 16, ["label"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 64))
    ]),
    _: 3
  }, 8, ["class"]))
}